// Pure helpers for the audit checklist row: practice-area code, evidence-owner
// roster resolution, and the evidence destination. No React here so each is
// unit-testable on its own.
// "Risk and Opp Management (RSK)" → { name: "Risk and Opp Management", code: "RSK" }.
// No trailing parenthetical → the area is returned as-is with no code.
export function parseReviewArea(reviewArea) {
    const m = /^(.*?)\s*\(([^()]+)\)\s*$/.exec(reviewArea);
    if (!m || !m[1]) return {
        name: reviewArea,
        code: ''
    };
    return {
        name: m[1],
        code: m[2].trim()
    };
}
// Evidence-owner text → roster role type codes. Anything not listed here
// (Pricing, HR, …) has no roster role and renders as a plain label.
const OWNER_ROLE_BY_TOKEN = {
    pm: {
        code: 'PM',
        label: 'Program Lead'
    },
    dpm: {
        code: 'Deputy',
        label: 'Deputy Program Lead'
    },
    'bu lead': {
        code: 'BU_Manager',
        label: 'Unit Manager'
    },
    quality: {
        code: 'Quality',
        label: 'Quality'
    }
};
// "PM, Pricing", "DPM or BU Lead" → one token per named owner, in order.
export function parseEvidenceOwner(evidenceOwner) {
    return evidenceOwner.split(/,|\s+or\s+/i).map((t)=>t.trim()).filter(Boolean).map((text)=>({
            text,
            role: OWNER_ROLE_BY_TOKEN[text.toLowerCase()]
        }));
}
// Resolve each token against the program's roster, preferring the primary
// holder of the role (else the first).
export function resolveOwnerChips(evidenceOwner, roster) {
    return parseEvidenceOwner(evidenceOwner).map((t, i)=>{
        const key = `${i}-${t.text}`;
        if (!t.role) return {
            kind: 'label',
            key,
            text: t.text
        };
        const holders = roster.filter((r)=>r.roleTypeCode === t.role?.code);
        const who = holders.find((r)=>r.isPrimary) ?? holders[0];
        if (!who) return {
            kind: 'unassigned',
            key,
            roleLabel: t.role.label
        };
        return {
            kind: 'person',
            key,
            name: who.contactDisplayName || who.contactEmail || t.role.label,
            roleLabel: who.roleTypeLabel || t.role.label
        };
    });
}
// Where a question's evidence lives. Every question points at Documents today;
// a future per-question destination adds an entry and names itself.
export const EVIDENCE_DESTINATIONS = {
    documents: {
        path: 'docs?tab=documents',
        label: 'Documents'
    }
};
export const DEFAULT_EVIDENCE_DESTINATION = EVIDENCE_DESTINATIONS.documents;
